// Carousel.jsx
import React, { useState, useEffect } from 'react';
import './CarouselPhone.scss';

import PhoneImg1 from '../../img/phone/phone-capture-app-1.webp'
import PhoneImg2 from '../../img/phone/phone-capture-app-2.webp'
import PhoneImg3 from '../../img/phone/phone-capture-app-3.webp'

const slideData = [
  {
    id: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-align-end-horizontal-icon lucide-align-end-horizontal"><rect width="6" height="16" x="4" y="2" rx="2"/><rect width="6" height="9" x="14" y="9" rx="2"/><path d="M22 22H2"/></svg>
    ),
    title: 'Billetera Virtual',
    description: 'Gestiona tu saldo disponible y mové tu plata de forma simple, rápida y segura desde un solo lugar.',
    buttonText: 'Descargar',
    image: PhoneImg1,
    altText: 'Interfaz de Billetera Virtual en el telefono',
  },
  {
    id: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-badge-dollar-sign-icon lucide-badge-dollar-sign"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 18V6"/></svg>
    ),
    title: 'Enviar dinero',
    description: 'Transferí a CBU, CVU o Alias en segundos y sin complicaciones desde tus contactos.',
    buttonText: 'Descargar',
    image: PhoneImg2,
    altText: 'Interfaz de Enviar dinero en el telefono',
  },
  {
    id: 3,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-credit-card-icon lucide-credit-card"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
    ),
    title: 'Pagar con QR',
    description: 'Pagá o cobrá escaneando un codigo QR. Una forma practica para operar sin efectivo.',
    buttonText: 'Descargar',
    image: PhoneImg3,
    altText: 'Interfaz de Pagar con QR en el telefono',
  },
];

const ArrowUpIcon = () => (
  <svg className='arrow-up' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 5 19 12"></polyline>
  </svg>
);

const ArrowDownIcon = () => (
  <svg className='arrow-down' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
);


const CarouselPhone = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const totalSlides = slideData.length;

  // Manejador para cambiar al slide anterior
  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
  };

  // Manejador para cambiar al siguiente slide
  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  };

  // Manejador para cambiar a un slide específico mediante el ícono
  const handleIconClick = (index) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex(index);
  };

  // Resetea el estado de animación después de que la animación CSS haya terminado
  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 500); // Duración de la animación en ms (debe coincidir con SASS)
      return () => clearTimeout(timer);
    }
  }, [isAnimating]);

  const currentSlide = slideData[activeIndex];

  return (
    <div className="container-carousel-vertical">
      <div className="vertical-carousel-container">

        <div className="carousel-navigation">
          <button
            className="nav-arrow up"
            onClick={handlePrev}
            aria-label="Slide anterior"
          >
            <ArrowUpIcon />
          </button>
          <div className="nav-icons">
            {slideData.map((slide, index) => (
              <div
                key={slide.id}
                className={`nav-icon ${index === activeIndex ? 'active' : ''}`}
                onClick={() => handleIconClick(index)}
                role="button"
                tabIndex={0}
                aria-label={`Ir al slide ${slide.title}`}
              >
                {slide.icon}
              </div>
            ))}
          </div>
          <button
            className="nav-arrow down"
            onClick={handleNext}
            aria-label="Siguiente slide"
          >
            <ArrowDownIcon />
          </button>
        </div>

        <div className={`carousel-content ${isAnimating ? 'animating' : ''}`}>
          <div className="text-content">
            <h2 className="slide-title">{currentSlide.title}</h2>
            <p className="slide-description">{currentSlide.description}</p>
            <button className="cta-button">{currentSlide.buttonText}</button>
          </div>
          <div className="image-content">
            <div className="phone-mockup">
              <img
                src={currentSlide.image}
                alt={currentSlide.altText}
                className="phone-screen"
                key={currentSlide.id} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselPhone;